export const IMAGES = {
  hero: [
    { url: `${process.env.REACT_APP_BACKEND_URL}/api/files/0666dd72-f4ca-4d3c-973d-26301bbe69a2`, rot: "-6deg" },
    { url: `${process.env.REACT_APP_BACKEND_URL}/api/files/e6fabc92-0524-4ee3-864d-caa04e3a5bb2`, rot: "4deg" },
    { url: `${process.env.REACT_APP_BACKEND_URL}/api/files/d7b0031b-3599-4850-a5e3-7d1e2499f39f`, rot: "-3deg" },
  ],
  artist: `${process.env.REACT_APP_BACKEND_URL}/api/files/2c0fb901-41d0-4bbf-a823-4f7f56bc0dca`,
  artist2: "https://images.pexels.com/photos/29612587/pexels-photo-29612587.jpeg?auto=compress&cs=tinysrgb&w=1000",
  display: "https://images.unsplash.com/photo-1760740921490-017e5ce652e7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  happy: "https://images.unsplash.com/photo-1562337404-3044c84ac061?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
  seedGallery: [
    "https://images.unsplash.com/photo-1695024253084-9adea9373bb3?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    "https://images.unsplash.com/photo-1540148579498-26fad6e9cb17?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    "https://images.unsplash.com/photo-1622157728508-9720f1ca31f7?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    "https://images.unsplash.com/photo-1760740921490-017e5ce652e7?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  ],
};
